<template>
  <v-card :href="url">
    <v-img
      class="white--text"
      height="300px"
      :src="imgSrc"
    >
      <v-container fill-height fluid>
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <span class="subheading">{{title}}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
  </v-card>
</template>

<script>

export default {
  props: ['imgSrc', 'title', "url"]
}
</script>

<style>

</style>
